const Flickity = require('flickity');
const bannerSlider = document.querySelector('.slider-banner');

if (bannerSlider) {
    let flkty = new Flickity( bannerSlider, {
        cellAlign: 'left',
        contain: true,
        // freeScroll: true,
        pageDots: false,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 5000,
    });

    window.addEventListener('load', () => {
        flkty.resize();
    })

    window.addEventListener('resize', () => {
        flkty.resize();
    })
}